export default __webpack_public_path__ + "static/media/bg_top.be4c115b.png";